"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DateTimeModifier = exports.DateTimeProviderImpl = exports.DateTimeProvider = void 0;
const UTCTimeZone_1 = require("./UTCTimeZone");
const check_1 = __importDefault(require("./check"));
const moment_1 = __importDefault(require("moment/moment"));
const Format_1 = require("./Format");
const clock_1 = require("@almservices-cl/clock");
Object.defineProperty(exports, "DateTimeModifier", { enumerable: true, get: function () { return clock_1.DateTimeModifier; } });
class DateTimeProvider {
}
exports.DateTimeProvider = DateTimeProvider;
class DateTimeProviderImpl {
    constructor(locale) {
        this.setFormats = (dateTimeFormat, dateFormat, timeFormat) => {
            this.dateTimeFormat = dateTimeFormat;
            this.dateFormat = dateFormat;
            this.timeFormat = timeFormat;
        };
        /**
         * @inheritDoc
         */
        this.current = (timezone) => (0, check_1.default)(this.fromDateTime(new Date().toISOString(), timezone));
        /**
         * @inheritDoc
         */
        this.fromDateTime = (dateTime, timezone) => {
            const momentDateTime = (0, moment_1.default)(dateTime, dateTime.substr(10, 1) === "T"
                ? "YYYY-MM-DDTHH:mm:ssZ"
                : this.dateTimeFormat);
            // TODO: Probably it is just a workaround?
            if (this.isDst(momentDateTime) && timezone.isDst) {
                timezone = new UTCTimeZone_1.UTCTimeZone((timezone.hours + 1), timezone.minutes, false);
            }
            return (0, check_1.default)(momentDateTime.utcOffset(timezone.toString()).format(this.dateTimeFormat));
        };
        this.isDst = (dateTime = (0, moment_1.default)()) => {
            const year = parseInt(dateTime.format("YYYY"));
            const month = parseInt(dateTime.format("MM"));
            const day = parseInt(dateTime.format("DD"));
            if (month > 3 && month < 10) {
                return true;
            }
            if (month < 3 || month > 10) {
                return false;
            }
            if (month === 3) {
                let summerTimeStart = (0, moment_1.default)(`${year}-03-31`);
                summerTimeStart = summerTimeStart.subtract(summerTimeStart.day(), "day");
                const summerTimeDayStart = parseInt(summerTimeStart.format("DD"));
                return summerTimeDayStart <= day;
            }
            let winterTimeStart = (0, moment_1.default)(`${year}-10-31`);
            winterTimeStart = winterTimeStart.subtract(winterTimeStart.day(), "day");
            const winterTimeDayStart = parseInt(winterTimeStart.format("DD"));
            return winterTimeDayStart > day;
        };
        /**
         * @inheritDoc
         */
        this.fromDateTimeToDate = (dateTime) => {
            const momentObj = (0, moment_1.default)(dateTime, this.dateTimeFormat);
            if (dateTime.substr(-6).match(/(-|\+)\d{2}:\d{2}/) === null) {
                return (0, check_1.default)(momentObj.format(this.dateFormat));
            }
            return (0, check_1.default)(momentObj.utcOffset(dateTime.substr(-6)).format(this.dateFormat));
        };
        /**
         * @inheritDoc
         */
        this.currentRaw = (timezone) => {
            return {
                date: (0, check_1.default)((0, moment_1.default)(new Date().toISOString()).utcOffset(timezone.toString()).format()),
                format: Format_1.FORMAT_RAW,
            };
        };
        this.dayOfWeek = (date, dateFormat) => {
            const day = (0, check_1.default)((0, moment_1.default)(date, dateFormat ? dateFormat : this.dateFormat).isoWeekday());
            // @ts-ignore
            return day - 1;
        };
        this.dayOfWeekRaw = (date, dateFormat) => {
            const dayNumber = (0, check_1.default)((0, moment_1.default)(date, dateFormat ? dateFormat : this.dateFormat).isoWeekday());
            return dayNumber === 7 ? 0 : dayNumber;
        };
        this.currentDate = () => (0, check_1.default)((0, moment_1.default)(new Date().toISOString()).format(this.dateFormat));
        this.currentTimestamp = () => (0, check_1.default)((0, moment_1.default)(new Date().toISOString()).unix());
        this.weekFromDate = (date) => {
            return (0, moment_1.default)(date).isoWeek();
        };
        this.locale = locale;
    }
    fromNow(date, timeZone) {
        let momentObj = (0, moment_1.default)(date, date.substr(10, 1) === "T" ? "YYYY-MM-DDTHH:mm:ssZ" : this.dateTimeFormat)
            .locale(this.locale.toString())
            .utcOffset(timeZone.toString());
        let momentNow = (0, moment_1.default)(this.currentRaw(UTCTimeZone_1.UTCTimeZone.z()).date);
        if (momentObj.diff(momentNow, "day") !== 0) {
            momentObj = momentObj.endOf("day");
            momentNow = momentNow.endOf("day");
        }
        return momentObj.from(momentNow);
    }
}
exports.DateTimeProviderImpl = DateTimeProviderImpl;
//# sourceMappingURL=DateTimeProvider.js.map